import { ColumnDataType } from 'console/table/tubular-types/column';
import { createColumn } from 'console/table/tubular-types/columnUtils';
export function createSimpleColumns(name, label) {
    return createColumn(name, {
        label,
        dataType: ColumnDataType.String,
        sortable: true,
        filterable: true,
        searchable: true,
    });
}
